module.exports = __webpack_public_path__ + "static/img/app-sub-img01@m.da590c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/app-sub-img01@m.png
// module id = 597o
// module chunks = 0